import { useEffect } from 'react';
import Modal from "../modal";
import Carousel from '../carousel';

interface CarouselModalProps {
    isOpen: boolean;
    onClose: any;
    autoForward?: boolean;
    interval?: number;
    imageList: string[];
}

function CarouselModal({
    isOpen,
    onClose,
    imageList = [],
    autoForward = true,
    interval = 2000
}: CarouselModalProps) {

    useEffect(() => {
        const disableZoom = (e: Event) => {
            if (
                (e instanceof WheelEvent && e.ctrlKey) ||
                e.type === 'gesturestart' ||
                e.type === 'gesturechange' ||
                e.type === 'gestureend'
            ) {
                e.preventDefault();
            }
        };

        if (isOpen) {
            document.body.style.overflow = 'hidden';
            document.body.style.touchAction = 'none';

            // Safe addEventListener calls
            window.addEventListener('wheel', disableZoom as EventListener, { passive: false });
            window.addEventListener('gesturestart', disableZoom as EventListener, { passive: false });
            window.addEventListener('gesturechange', disableZoom as EventListener, { passive: false });
            window.addEventListener('gestureend', disableZoom as EventListener, { passive: false });
        }

        return () => {
            document.body.style.overflow = '';
            document.body.style.touchAction = '';

            window.removeEventListener('wheel', disableZoom as EventListener);
            window.removeEventListener('gesturestart', disableZoom as EventListener);
            window.removeEventListener('gesturechange', disableZoom as EventListener);
            window.removeEventListener('gestureend', disableZoom as EventListener);
        };
    }, [isOpen]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="sm">
            <h4 className="text-2xl mb-2 font-bold font-aeonikBold mb-4 mt-3">Attachments</h4>
            <Carousel images={imageList} autoForward={autoForward} interval={interval} />
        </Modal>
    );
}

export default CarouselModal;